// Public invoice service — no authentication
// Magic-link facture client : /i/:token (route SPA) → /api/v1/public/invoices/:token (API JSON)
// + GET /api/v1/public/invoices/:token/pdf pour le téléchargement PDF.

import { PUBLIC_API_BASE, publicGet } from "./public-fetch"

export interface PublicInvoiceLine {
  description: string
  quantity: string | number
  unit_price: string | number
  total_amount: string | number
}

export interface PublicInvoiceResponse {
  invoice_number: string
  status_code: string
  status_label: string | null
  issue_date: string
  due_date: string
  tenant: {
    name: string
    logo_url: string | null
  }
  client: {
    account_name: string
    contact_name: string | null
    contact_email: string | null
    billing_address: string | null
    billing_postal_code: string | null
    billing_city: string | null
  }
  lines: PublicInvoiceLine[]
  subtotal_amount: string | number
  discount_amount: string | number
  tax_amount: string | number
  total_amount: string | number
  currency: string
  notes: string | null
}

const PUBLIC_API_PREFIX = "/api/v1/public/invoices"

export function getPublicInvoice(token: string) {
  return publicGet<PublicInvoiceResponse>(`${PUBLIC_API_PREFIX}/${token}`)
}

export function publicInvoicePdfUrl(token: string): string {
  return `${PUBLIC_API_BASE}${PUBLIC_API_PREFIX}/${token}/pdf`
}
